<template>
  <div class="app-wrapper">
    <div class="app-icon"><img src="/logos/PALC_Marque_White.svg" /></div>
    <div class="app-title">
      <span class="heading3">
        {{ $t('do_you_want_to_have_the_paradise_experience') }}&nbsp;
        <span class="heading3-italic">{{ $t('install_our_app') }}</span></span
      >
    </div>
    <div class="app-action">
      <img
        src="/app/ios.svg"
        @click="window.open(config.public.iosAppUrl, '_blank')"
      />
      <img
        src="/app/android.svg"
        @click="window.open(config.public.androidAppUrl, '_blank')"
      />
    </div>
  </div>
</template>

<script>
export default defineComponent({
  setup() {
    const config = useRuntimeConfig()

    return {
      config
    }
  },
  data() {
    return {
      window
    }
  }
})
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 356px;
  background: var(--brand-off-black);
  padding: 80px 0px 80px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  .app-icon {
    display: flex;
    justify-content: center;
    padding: 0px 24px;
    width: 100%;
    margin-bottom: 24px;
  }
  .app-title {
    text-align: center;
    padding: 0px 24px;
    width: 100%;
    color: var(--brand-white);
    margin-bottom: 24px;
  }
  .app-action {
    display: flex;
    justify-content: center;
    padding: 0px 24px;
    width: 100%;
    img {
      cursor: pointer;
      display: inline-block;
      &:first-of-type {
        margin-right: 24px;
      }
    }
  }
}
</style>